import React from "react";
import { useDispatch } from "react-redux";
import PremiumIcon from "@atlaskit/icon/core/premium";
import { showWizard } from "../redux/actions/wizardActions";
import Button from "@atlaskit/button/new";
import { ButtonGroup } from "@atlaskit/button";
import StartWizard from "../wizards/modal/StartWizardModal";
import AddIcon from "@atlaskit/icon/core/add";
import { createFlow } from "../redux/actions/integrationActions";
import { newFlow } from "../common/factory/flow.factory";
const CreateButton = () => {
  const dispatch = useDispatch();

  const runWizard = () => {
    //console.log("Create from template");
    dispatch(showWizard(true));
  };

  const onClick = (e) => {
    dispatch(createFlow(newFlow("Integration " + new Date().toISOString())));
  };

  return (
    <>
      <ButtonGroup>
        <Button
          appearance="primary"
          iconBefore={AddIcon}
          onClick={onClick}
        >
          Create Integration
        </Button>
        <Button iconBefore={PremiumIcon} onClick={runWizard}>
          Wizard
        </Button>
      </ButtonGroup>

      <StartWizard />
    </>
  );
};
export default CreateButton;
